export const enum FormPropertyReportStatechartActionEnum {
  /**
   * Validating form fields
   */
  validateFields = 'validateFields',

  /**
   * Show errors from server
   */
  showErrors = 'showErrors',

  /**
   * Execute captcha
   */
  executeCaptcha = 'executeCaptcha',

  /**
   * Send create report request to server
   */
  sendCreateReportRequest = 'sendCreateReportRequest',

  /**
   * Check if report form has attachment
   */
  checkIfHasAttachment = 'checkIfHasAttachment',

  /**
   * Upload attachment to server
   */
  uploadAttachment = 'uploadAttachment',

  /**
   * Check if report was already sent (in case when failed to upload attachment)
   */
  checkIfWasAlreadySent = 'checkIfWasAlreadySent',

  /**
   * Set form submitted status (show success message)
   */
  setSubmittedStatus = 'setSubmittedStatus',

  /**
   * Set form submitting status (show loader)
   */
  setSubmittingStatus = 'setSubmittingStatus',

  doUserUpdate = 'doUserUpdate',
}
